import styled from "styled-components";

const DropDownItem = styled.option``;

export default DropDownItem;
